import musickk from "./musicapp.JPG";
import galxe from "./galxe.JPG";
import dmjs from "./Dmjs.JPG";
import food from "./fooddelivery.JPG";
import netflix from "./netflix.JPG";
import pizza from "./pizza-order.png";
import adilo from "./adilo.png";
import recipe from "./recipe.png";
import eVoting from "./e-voting.png";
import chat from "./dmj_chat.png";

export const Projects = [
  {
    title: "DMJ Chat",
    website: "https://dmj-chat.vercel.app/",
    Image: chat,
    tag1: "NextJs",
    tag2: "Tailwindcss",
    tag3: "Typescript",
    tag4: "react-markdown, rehype-highlight, remark-gfm",
  },
  {
    title: "Galxe Landing Page",
    website: "https://galxe-project.vercel.app/",
    Image: galxe,
    tag1: "NextJs",
    tag2: "Tailwindcss",
    tag3: "Typescript",
    tag4: "React Framer Motion",
  },

  {
    title: "DMJ's Blog",
    website: "https://dmj-s-blog.vercel.app/",
    Image: dmjs,
    tag1: "ReactJs",
    tag2: "Tailwindcss",
    tag3: "NodeJS",
    tag4: "MongoDB",
  },

  {
    title: "Netflix Clone",
    website: "https://netflix-clone-82119.web.app/",
    Image: netflix,
    tag1: "ReactJs",
    tag2: "React Hooks",
    tag3: "Rest Api",
    tag4: "Axios",
  },

  {
    title: "Pizza Company",
    website: "https://dmj-pizza.vercel.app/",
    Image: pizza,
    tag1: "VueJs",
    tag2: "Laravel Php",
    tag3: "Pinia State Management",
    tag4: "Axios",
  },
  {
    title: "ADILO'S Project",
    website: "https://adilo.vercel.app/",
    Image: adilo,
    tag1: "VueJs",
    tag2: "Vanilla Css",
    tag3: "Chart.js",
    tag4: "CSS3",
  },
  {
    title: "Fooddelivery",
    website: "https://fooddelivery-pi.vercel.app/",
    Image: food,
    tag1: "ReactJS",
    tag2: "Material UI",
    tag3: "SwiperJS",
    tag4: "React Router",
  },

  {
    title: "E-Voting",
    website: "https://e-voting-collab.vercel.app/",
    Image: eVoting,
    tag1: "ReactJs",
    tag2: "Tailwind Css",
    tag3: "Responsive Design",
    tag4: "Wallet Connect - static",
  },

  {
    title: "MUSICKK",
    website: "https://musicapp-mu.vercel.app/",
    Image: musickk,
    tag1: "ReactJs",
    tag2: "React Hook",
    tag3: "SwiperJs",
    tag4: "Landing Pagge",
  },

  {
    title: "Recipes",
    website: "https://my-wildrecipes.vercel.app/",
    Image: recipe,
    tag1: "Html",
    tag2: "Vanilla Css",
    tag3: "Grid and FlexBox",
    tag4: "Axios",
  },
];
